<mat-form-field appearance="outline" class="search-field">
  <mat-label>Buscar categoría</mat-label>
  <mat-icon matPrefix>search</mat-icon>
  <input matInput [formControl]="searchControl" placeholder="Escriba para filtrar...">
  @if (searchControl.value) {
    <button matSuffix mat-icon-button (click)="clearSearch()" aria-label="Limpiar búsqueda">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>

@if (loading()) {
  <p class="loading-text">Cargando categorías...</p>
} @else if (filteredTree().length === 0) {
  <p class="no-results">No se encontraron categorías.</p>
} @else {
  <mat-tree #tree="matTree" [dataSource]="filteredTree()" [childrenAccessor]="childrenAccessor">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      {{ node.nombre }}

      <div class="form-check form-check-inline checkbox_select">
        <input
          class="form-check-input"
          type="radio"
          name="inlineRadioOptions"
          [id]="'radio-' + node.id"
          [value]="node.id"
          (click)="handleCheck(node.id)"
        />
        <label class="form-check-label" [for]="'radio-' + node.id"></label>
      </div>
    </mat-tree-node>

    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.nombre">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>

      {{ node.nombre }}
    </mat-tree-node>
  </mat-tree>
}
